export enum JobStatusEnum {
    OPEN = "OPEN",
    UNDER_REVIEW = "UNDER_REVIEW",
    CLOSED = "CLOSED",
    REJECTED = "REJECTED",
    DEMO_POST = "DEMO_POST",
    DRAFT = "DRAFT",
    ARCHIVED = "ARCHIVED",
}